<script setup lang="ts">
defineProps({ blok: Object })
const items = ['climate', 'mining', 'disease']
</script>

<template>
    <section class="section relative border-t border-chsc-raw">
        <!-- <div class="absolute top-0 left-0 w-full h-[300px] bg-gradient-to-b from-chsc-raw to-transparent z-[-1]" /> -->
        <UiContainer>
            <header class="global-header z-1 relative">
                <StoryblokRichText :doc="blok?.header" />
            </header>
            <div class="mt-32 grid grid-cols-3 gap-x-12 max-[769px]:grid-cols-1 max-[769px]:gap-x-0 max-[769px]:gap-y-20">
                <div
                    v-for="item in items"
                    :key="item"
                    class="min-h-full"
                >
                    <div
                        v-motion-slide-visible-once-bottom
                        class="min-h-full border-[2px] border-chsc-indigo-500 rounded-lg p-6"
                    >
                        <div class="flex items-center justify-center relative">
                            <div class="absolute top-0 left-0 w-full h-full flex items-center justify-center -translate-y-1/2 bg-white">
                                <img
                                    :src="blok?.[`${item}_icon`].filename"
                                    :alt="blok?.[`${item}_icon`].alt"
                                >
                            </div>
                            <div class="z-1 realtive mt-32 text-center [&>h5]:font-londrina-solid [&>h5]:text-chsc-indigo-500 [&>h5]:text-4xl [&>h5]:mb-4 [&>p]:font-eb-garamond [&>p]:text-2xl">
                                <StoryblokRichText :doc="blok?.[`${item}_description`]" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-20">
                <div class="font-londrina-solid text-chsc-indigo-500 fs-6xl mb-4 text-center [&>p>strong]:text-chsc-yellow [&>p>strong]:font-normal">
                    <StoryblokRichText :doc="blok?.claim" />
                </div>
            </div>
            <div
                v-motion-slide-visible-once-bottom
                class="relative mt-20 border-[2px] border-chsc-indigo-500 rounded-[40px] p-12"
            >
                <h4 class="absolute top-0 left-1/2 -translate-y-1/2 -translate-x-1/2 bg-white px-4 fs-6xl font-londrina-solid text-chsc-yellow mb-6">
                    {{ blok?.next_title }}
                </h4>
                <div class="[&>div>p]:font-londrina-solid [&>div>p]:fs-4xl [&>div>p]:text-chsc-indigo-500 [&>div>p]:text-center [&>div>p>strong]:fs-8xl [&>div>p>strong]:text-chsc-yellow [&>div>p>strong]:font-normal max-[641px]:grid-cols-1 max-[641px]:gap-x-0 max-[641px]:gap-y-6">
                    <div>
                        <StoryblokRichText :doc="blok?.next_description" />
                    </div>
                </div>
            </div>
        </UiContainer>
    </section>
</template>
